import { UserPlus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';
import { type KpiResponseDto } from '../types';

export const BulkAddKpiAssignees = (props: { kpi: KpiResponseDto }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(assigneeIds) =>
        dataProvider.addKpiAssignees({
          data: assigneeIds.map((assigneeId) => ({
            kpiId: props.kpi.id,
            unitId: assigneeId,
          })),
        })
      }
      label="ra.action.add"
      buttonIcon={<UserPlus />}
      successMessage="moonstar.kpiAssignees.add.successMessage"
    />
  );
};
